(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    const sidebar = event.target.closest('.rn-storefront-collection [data-collection-sidebar]');
    if (!sidebar) return;
    const trigger = sidebar.closest('collection-component').querySelector('[data-aria-toggle]');
    requestAnimationFrame(() => trigger?.focus());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-menu"] && !Shopify.designMode) return;
  try {
    
  const menuObservers = new WeakMap();
  const syncMenuExpandedState = (menu) => {
    menu.querySelectorAll('mobile-sliderule').forEach((sliderule) => {
      const trigger = sliderule.querySelector('[data-sliderule-open]');
      const panel = sliderule.querySelector(':scope > [data-sliderule]');
      if (trigger && panel) trigger.setAttribute('aria-expanded', String(panel.classList.contains('is-visible')));
    });
  };
  const observeMenu = (scope) => {
    scope.querySelectorAll('.rn-mobile-menu').forEach((menu) => {
      if (menu.dataset.rnObserved) return;
      menu.dataset.rnObserved = 'true';
      const observer = new MutationObserver(() => syncMenuExpandedState(menu));
      menu.querySelectorAll('[data-sliderule-pane]').forEach((pane) => {
        observer.observe(pane, {attributes: true, subtree: true, attributeFilter: ['class', 'data-sliderule-pane']});
      });
      syncMenuExpandedState(menu);
      menuObservers.set(menu, observer);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => observeMenu(document), {once: true});
  else observeMenu(document);
  document.addEventListener('shopify:section:load', (event) => observeMenu(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.rn-mobile-menu').forEach((menu) => {
      menuObservers.get(menu)?.disconnect();
      menuObservers.delete(menu);
    });
  });
  // At the root, Escape closes the drawer instead of decrementing the native submenu level below zero.
  document.addEventListener('keyup', (event) => {
    if (event.code !== 'Escape' || !(event.target instanceof Element)) return;
    const sliderule = event.target.closest('.rn-mobile-menu mobile-sliderule');
    if (!sliderule) return;
    const pane = sliderule.closest('[data-sliderule-pane]');
    if (!pane || Number(pane.dataset.sliderulePane) > 0) return;
    const drawer = sliderule.closest('header-drawer');
    if (!drawer?.classList.contains('is-open')) return;
    event.stopPropagation();
    drawer.dispatchEvent(new CustomEvent('theme:drawer:close'));
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rn-editorial-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rn-hero-rotator')) {
  customElements.define('rn-hero-rotator', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('[data-rn-slide]')];
      if (this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dots = [...this.querySelectorAll('[data-rn-dot]')];
      this.pauseButton = this.querySelector('[data-rn-pause]');
      this.querySelector('.rn-final-hero__controls').hidden = false;
      this.current = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => {
        this.show(i); this.paused = true; this.sync();
      }, options));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.sync(); } }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
      this.sync();
    }
    show(index) {
      this.current = index;
      this.slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
    }
    sync() {
      clearInterval(this.timer);
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      this.pauseButton.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      if (!this.paused && !this.hovered && !this.focused && !document.hidden) {
        this.timer = setInterval(() => this.show((this.current + 1) % this.slides.length), Number(this.dataset.interval) || 5000);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rn-help-tabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rn-help-tabs'))customElements.define('rn-help-tabs',class extends HTMLElement{
 connectedCallback(){this.onClick=e=>{const t=e.target.closest('[data-help-tab]');if(t)this.select(t)};this.onKey=e=>{const t=e.target.closest('[data-help-tab]');if(!t)return;const tabs=[...this.querySelectorAll('[data-help-tab]')];let i=tabs.indexOf(t);if(e.key==='ArrowRight'||e.key==='ArrowLeft')i=(i+1)%tabs.length;else if(e.key==='Home')i=0;else if(e.key==='End')i=tabs.length-1;else return;e.preventDefault();this.select(tabs[i]);tabs[i].focus()};this.onBlock=e=>{const item=e.target.closest('.rn-help__item');if(!item)return;const panel=item.closest('[data-help-panel]');const tab=this.querySelector('[data-help-tab="'+panel.dataset.helpPanel+'"]');if(tab)this.select(tab);item.open=true};this.addEventListener('shopify:block:select',this.onBlock);this.addEventListener('click',this.onClick);this.addEventListener('keydown',this.onKey)}
 disconnectedCallback(){this.removeEventListener('shopify:block:select',this.onBlock);this.removeEventListener('click',this.onClick);this.removeEventListener('keydown',this.onKey)}
 select(tab){this.querySelectorAll('[data-help-tab]').forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1});this.querySelectorAll('[data-help-panel]').forEach(p=>p.hidden=p.dataset.helpPanel!==tab.dataset.helpTab)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subcollections"]) return;
  try {
    
(() => {
  if (window.rnCollectionNavigation) return;
  window.rnCollectionNavigation = true;
  const cache = new Map();
  let path = location.pathname;
  let controller;
  let requestId = 0;
  const selector = '.rn-collection-tabs a[href]';
  const prepare = (href, signal) => {
    if (cache.has(href)) return Promise.resolve(cache.get(href));
    return fetch(href, {signal, credentials: 'same-origin'}).then(response => {
      if (!response.ok) throw new Error('Collection unavailable');
      return response.text();
    }).then(html => {
      cache.set(href, html);
      if (cache.size > 8) cache.delete(cache.keys().next().value);
      return html;
    });
  };
  const syncRails = () => document.querySelectorAll('.rn-collection-tabs nav').forEach(nav => {
    const rail = nav.querySelector('ul');
    if (!rail) return;
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      nav.classList.toggle('rn-rail-overflow', max > 2);
      nav.querySelector('[data-rn-rail="prev"]')?.toggleAttribute('disabled', rail.scrollLeft <= 2);
      nav.querySelector('[data-rn-rail="next"]')?.toggleAttribute('disabled', rail.scrollLeft >= max - 2);
    };
    if (!rail.dataset.rnBound) { rail.dataset.rnBound = 'true'; rail.addEventListener('scroll', update, {passive: true}); }
    update();
  });
  const navigate = async (href, historyChange = false) => {
    const url = new URL(href, location.href);
    const main = document.querySelector('#MainContent');
    if (!main || url.origin !== location.origin) return;
    controller?.abort();
    controller = new AbortController();
    const id = ++requestId;
    main.setAttribute('aria-busy', 'true');
    main.classList.add('rn-collection-loading');
    try {
      const html = await prepare(url.href, controller.signal);
      if (id !== requestId) return;
      const page = new DOMParser().parseFromString(html, 'text/html');
      const nextMain = page.querySelector('#MainContent');
      if (!nextMain?.querySelector('collection-component') || !nextMain.querySelector('.rn-collection-tabs')) throw new Error('Unsupported collection');
      const savedScroll = new Map([...main.querySelectorAll('.rn-collection-tabs nav')].map(nav => [nav.className, nav.querySelector('ul')?.scrollLeft || 0]));
      nextMain.querySelectorAll('script').forEach(script => script.remove());
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      main.replaceChildren(...nextMain.childNodes);
      // Theme toggles normally bind only on initial page load.
      main.querySelectorAll('[data-aria-toggle]').forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (!panel) return;
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          panel.classList.toggle('expanded', expanded);
        });
      });
      document.title = page.title;
      const canonical = page.querySelector('link[rel="canonical"]');
      if (canonical) document.querySelector('link[rel="canonical"]')?.setAttribute('href', canonical.href);
      if (!historyChange) history.pushState({rnCollection: true}, '', url.href);
      path = url.pathname;
      requestAnimationFrame(() => {
        main.querySelectorAll('.rn-collection-tabs nav').forEach(nav => {
          const rail = nav.querySelector('ul');
          if (!rail) return;
          rail.scrollLeft = savedScroll.get(nav.className) || 0;
          const active = rail.querySelector('[aria-current="page"]');
          if (active) {
            const x = active.offsetLeft - rail.offsetLeft;
            if (x < rail.scrollLeft || x + active.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = Math.max(0, x - (rail.clientWidth - active.offsetWidth) / 2);
          }
        });
        syncRails();
        const tabs = main.querySelector('.rn-collection-tabs');
        if (tabs) window.scrollTo({top: window.scrollY + tabs.getBoundingClientRect().top - 16, behavior: 'instant'});
        const heading = main.querySelector('h1');
        if (heading) { heading.tabIndex = -1; heading.focus({preventScroll: true}); }
      });
      document.dispatchEvent(new CustomEvent('theme:resize:width'));
    } catch (error) {
      if (error.name !== 'AbortError' && id === requestId) location.assign(url.href);
    } finally {
      if (id === requestId) { main.removeAttribute('aria-busy'); main.classList.remove('rn-collection-loading'); }
    }
  };
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-rn-rail]');
    if (arrow) {
      const rail = arrow.closest('nav').querySelector('ul');
      rail.scrollBy({left: (arrow.dataset.rnRail === 'next' ? 1 : -1) * rail.clientWidth * .75, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    const link = event.target.closest(selector);
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || window.Shopify?.designMode) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || !url.pathname.includes('/collections/')) return;
    event.preventDefault();
    if (url.pathname === location.pathname && url.search === location.search) return;
    navigate(url.href);
  });
  window.addEventListener('popstate', event => {
    if (!document.querySelector('.rn-collection-tabs') || location.pathname === path) return;
    if (!location.pathname.includes('/collections/')) return;
    event.stopImmediatePropagation();
    navigate(location.href, true);
  }, true);
  let prefetchTimer;
  document.addEventListener('pointerover', event => {
    const link = event.target.closest(selector);
    if (!link || window.Shopify?.designMode || navigator.connection?.saveData) return;
    clearTimeout(prefetchTimer);
    prefetchTimer = setTimeout(() => prepare(link.href).catch(() => {}), 100);
  });
  window.addEventListener('resize', syncRails);
  document.addEventListener('shopify:section:load', syncRails);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncRails); else syncRails();
})();

  } catch(e) { console.error(e); }
})();
})();
